import {
  SET_LOADING,
  SET_STREAM_NEW_ENTRIES
} from './types'

export const state = {
  loading: true,
  stream: {
    newEntries: false
  }
}

export const mutations = {
  [SET_LOADING] (state, value) {
    state.loading = value
  },
  [SET_STREAM_NEW_ENTRIES] (state, value) {
    state.stream.newEntries = value
  }
}

export const actions = {
  loadingStart ({ commit }) {
    commit(SET_LOADING, true)
  },
  loadingDone ({ commit }) {
    setTimeout(() => {
      commit(SET_LOADING, false)
    }, 500)
  },
  setStreamNewEntries ({ commit }, value) {
    commit(SET_STREAM_NEW_ENTRIES, value)
  }
}

export const getters = {}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}



// WEBPACK FOOTER //
// ./src/store/modules/app/app.js